import { useAuth, useClerk } from '@clerk/clerk-react';
import { Button, ConfirmModal } from '@vrplatform/components';
import { useIntercom, useMe, useMutation } from '@vrplatform/data';
import { useState } from 'react';
import { EmptyViewWrapper } from '../../components';

const EmptyTeamView = () => {
  const { signOut } = useClerk();
  const { show: openIntercom } = useIntercom();
  const { actor } = useAuth();
  const [deleteModal, setDeleteModal] = useState(false);

  return (
    <EmptyViewWrapper
      title="No team associated with this account"
      description="We have not been able to find any team linked to this account. Please reach out to support. Alternatively, you can also delete your account from our systems."
      actions={
        <>
          {!!openIntercom && (
            <Button onClick={openIntercom} leftIcon={'CommentQuestionIcon'}>
              Contact Support
            </Button>
          )}

          {!actor && (
            <>
              <Button
                onClick={() => setDeleteModal(true)}
                leftIcon={'TrashIcon'}
              >
                Delete Account
              </Button>

              <DeleteAccountModal
                closeModal={() => setDeleteModal(false)}
                opened={deleteModal}
              />
            </>
          )}

          <Button
            variant="light"
            onClick={() => signOut()}
            leftIcon={'LogOut2Icon'}
          >
            Sign Out
          </Button>
        </>
      }
    />
  );
};

const DeleteAccountModal = ({
  closeModal,
  opened,
}: {
  closeModal: () => void;
  opened: boolean;
}) => {
  const { id: meId } = useMe();
  const { signOut } = useClerk();

  const { mutate, loading } = useMutation(
    (q, args: { userId: string }) => {
      return q.deleteUserById({ id: args.userId })?.id;
    },
    {
      invalidateQueryKeys: ['team', 'users'],
    }
  );

  const submitDelete = async () => {
    return await mutate({ args: { userId: meId } }).then(() => {
      closeModal();
      signOut();
    });
  };

  return (
    <ConfirmModal
      type="delete"
      opened={opened}
      closeModal={closeModal}
      onSubmit={submitDelete}
      loading={loading}
      title={'Are you sure to delete your account?'}
      subtitle={
        'This action is irreversible. You will not be able to access your account or recover any data.'
      }
    />
  );
};

export default EmptyTeamView;
